<nav class="navbar sticky-top navbar-expand-lg bg-body-tertiary border-bottom">
  <div class="container-fluid">
    <a class="navbar-brand mb-0 h1" routerLink="services/list">DESP Backoffice</a>

    <!-- hamburger 4 small screens -->
    <button class="navbar-toggler" type="button"
      data-bs-toggle="collapse" data-bs-target="#navbarNav"
      aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarNav">

      <!-- wrap container - allows multi-row -->
      @if (loggedUser) {
        <div class="menu-wrap d-flex flex-fill align-items-center ">
          <ul class="navbar-nav flex-wrap me-auto gap-1">
            @for (item of headerMenu; track item) {
              <li class="nav-item">
                <a hasAnyRole
                  [viewRoles]="item.viewRoles"
                  class="nav-link px-2 py-1"
                  [routerLink]="item.router"
                  routerLinkActive="active">
                  {{ item.title }}
                </a>
              </li>
            }
          </ul>
        </div>
      }

      <!-- user block -->
      <div class="navbar-nav ms-auto user-block">
        <div class="nav-item d-flex flex-column align-items-center">
          <span class="navbar-text mb-0 small username-block">
            {{ loggedUser?.preferred_username }}
          </span>
          <span class="navbar-text mt-0 small username-block">
            ({{ loggedUser?.resource_access?.srvregbe_public?.roles?.[0] }})
          </span>
          <button class="btn btn-link nav-link pt-2 small" (click)="logout()">Logout</button>
        </div>
      </div>

    </div>
  </div>
</nav>
